var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M14.6542 3.99987C14.9303 4.22307 14.9732 4.62784 14.75 4.90395L7.71501 13.6066L7.71348 13.6085C7.57659 13.7766 7.40386 13.9124 7.2072 14.0052C7.01047 14.098 6.79529 14.1451 6.57747 14.1426C6.35607 14.1397 6.13816 14.0857 5.94134 13.9851C5.74514 13.8848 5.57491 13.7411 5.44262 13.5659C5.44224 13.5654 5.44187 13.5649 5.4415 13.5644L3.23846 10.6688C3.02348 10.3863 3.07826 9.98296 3.36082 9.76798C3.64337 9.553 4.04671 9.60779 4.26168 9.89034L6.46865 12.7911C6.485 12.8128 6.50504 12.8293 6.52651 12.8402C6.54791 12.8512 6.57069 12.8567 6.59326 12.857C6.61547 12.8572 6.63734 12.8524 6.65857 12.8424C6.67966 12.8325 6.69954 12.8173 6.71617 12.7971C6.71634 12.7969 6.7165 12.7967 6.71666 12.7965L13.7501 4.09568C13.9733 3.81957 14.3781 3.77667 14.6542 3.99987Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e4694cd4a495cacf46d462eed925e6e1.svg";
export { ForwardRef as ReactComponent };